export type TicketGender = 'male' | 'female' | 'other' | '';
export type PronounSet = 'he_him' | 'she_her' | 'they_them' | '';

export const PRONOUN_SET_OPTIONS: { value: PronounSet; label: string }[] = [
  { value: 'he_him', label: 'He / His' },
  { value: 'she_her', label: 'She / Her' },
  { value: 'they_them', label: 'They / Their' },
];

export function defaultPronounSetForGender(gender: TicketGender): PronounSet {
  if (gender === 'male') return 'he_him';
  if (gender === 'female') return 'she_her';
  return '';
}

export function genderRequiresPronounSelection(gender: TicketGender): boolean {
  return gender === 'other';
}

export function isGenderPronounValid(
  gender: TicketGender,
  pronounSet: PronounSet,
): boolean {
  if (!gender) return true;
  if (gender === 'male' || gender === 'female') return true;
  return pronounSet !== '';
}

export function formatGenderLabel(gender: string | null | undefined): string {
  if (gender === 'male') return 'Male';
  if (gender === 'female') return 'Female';
  if (gender === 'other') return 'Other';
  return 'Not specified';
}

export function formatPronounSetLabel(
  pronounSet: string | null | undefined,
): string {
  const match = PRONOUN_SET_OPTIONS.find((o) => o.value === pronounSet);
  return match?.label ?? '';
}
